import NFT_ABI from './nftABI.json';
import NFT_REWARDS_ABI from './nftRewardsABI.json';
import TOKEN_ABI from './tokenABI.json';

const config = {
    // Feature flags
    SHOW_REWARDS: false,  // Set to true to show the Rewards section on /plots page

    WEBHOOK_URL: 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/',
    NFT_CA: '0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e',
    NFT_ABI,
    NFT_REWARDS_CA: '0x262457Ad3F751C7027C5e632e862cabf497bC082', // 0x134C638F1c44a06000a4A3738A0dD34BA9e47070
    NFT_REWARDS_ABI,
    // [
    //     {
    //         "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
    //         "name": "getTokenIdAllocation",
    //         "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    //         "stateMutability": "view",
    //         "type": "function"
    //     },
    //     {
    //         "inputs": [
    //             {"internalType": "address", "name": "wallet", "type": "address"},
    //             {"internalType": "uint256[]", "name": "tokenIds", "type": "uint256[]"}
    //         ],
    //         "name": "claimAllocation",
    //         "outputs": [],
    //         "stateMutability": "nonpayable",
    //         "type": "function"
    //     },
    //     {
    //         "anonymous": false,
    //         "inputs": [
    //             {"indexed": true, "internalType": "address", "name": "wallet", "type": "address"},
    //             {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"},
    //             {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    //         ],
    //         "name": "RewardClaimed",
    //         "type": "event"
    //     }
    // ],
    TOKEN_CA: '0x6e1307cb2e16e53718d9a69026c14a4dd1ee2e24',
    TANG_CA: '0xCC3ABa72BB8D3e38745b4FB9941141a85B3b1fd8',
    NFT_TANG_CA: '0xf9257167ea5f0bffd4f1c727a2c35a00ac1dea90',
    SUBPAGES: {
        TANG: {
            TOKEN_CA: '0xCC3ABa72BB8D3e38745b4FB9941141a85B3b1fd8',
            NFT_CA: '0xf9257167ea5f0bffd4f1c727a2c35a00ac1dea90',
        },
        DOB: {
            TOKEN_CA: '0x0B7056f5e82B254D93BD9A1C860ff069340f347f',
            NFT_CA: '0xdd49c98ba4308ce2c6d11cc37a9040827096bee7',
        },
        PREME: {
            TOKEN_CA: '0x6e1307cb2e16e53718d9a69026c14a4dd1ee2e24',
            NFT_CA: '0x79bd982be6446be8d42497c149b2efe4d3e1f53d',
            canUseEth: true,
        },
        ZORA: {
            TOKEN_CA: '0x5ca35371263CA25e0BC8005fB44e0c37D0a0BdfD', // 0x6a994a26d713564a9453c24859585f860f129a96
            NFT_CA: '0x1b56eda8dfd245b5d336cc145f49afb4e1fc426a', // 0xef15adef3e3d321dde5c378f16f3e71ba6c6a0fe
            canUseEth: false,
        },
    },
    TOKEN_ABI,
    LOCAL_STORAGE_KEYS: {
        NEWSLETTER_SUBSCRIBED: 'NEWSLETTER_SUBSCRIBED',
    }
}
export default config;

// const transferABI = [
//     // {
//     //   name: "transfer",
//     //   type: "function",
//     //   inputs: [
//     //     {
//     //       name: "_to",
//     //       type: "address",
//     //     },
//     //     {
//     //       type: "uint256",
//     //       name: "_tokens",
//     //     },
//     //   ],
//     //   constant: false,
//     //   outputs: [],
//     //   payable: false,
//     // },
//     {
//       "inputs": [
//         {
//           "internalType": "address",
//           "name": "to",
//           "type": "address"
//         },
//         {
//           "internalType": "uint256",
//           "name": "value",
//           "type": "uint256"
//         },
//         {
//           "internalType": "string",
//           "name": "paintData",
//           "type": "string"
//         }
//       ],
//       "name": "paint",
//       "outputs": [
//         {
//           "internalType": "bool",
//           "name": "",
//           "type": "bool"
//         }
//       ],
//       "stateMutability": "nonpayable",
//       "type": "function"
//     },
  
//     {
//       "inputs": [
//         {
//           "internalType": "address",
//           "name": "owner",
//           "type": "address"
//         }
//       ],
//       "name": "balanceOf",
//       "outputs": [
//         {
//           "internalType": "uint256",
//           "name": "",
//           "type": "uint256"
//         }
//       ],
//       "stateMutability": "view",
//       "type": "function"
//     },
//     {
//       "inputs": [
//           {
//               "internalType": "address",
//               "name": "spender",
//               "type": "address"
//           },
//           {
//               "internalType": "uint256",
//               "name": "value",
//               "type": "uint256"
//           }
//       ],
//       "name": "approve",
//       "outputs": [
//           {
//               "internalType": "bool",
//               "name": "",
//               "type": "bool"
//           }
//       ],
//       "stateMutability": "nonpayable",
//       "type": "function"
//     },
//   ];